import { json } from '../c-mp/fun/json'
import { FULL_DATE_LENGTH } from '../model/FULL_DATE_LENGTH'

export function endOf(date: string) {
	if (date.length === FULL_DATE_LENGTH) return date
	else if (date.length === 7) {
		if (date.endsWith('02'))
			return (
				date + '-' + new Date(parseInt(date.slice(0, 4), 10), 2, 0).getDate()
			)
		else if (/(?:01|03|05|07|08|10|12)$/.test(date)) return date + '-31'
		else return date + '-30'
	} else if (date.length === 4) return date + '-12-31'
	else throw new Error(json`[ta5ta4] Invalid date: ${date}`)
}
